import styled, { css } from 'styled-components'
import { TTypoName, TTypoSize } from './type'
import { body, display, headline, label, paragraph, title } from './const'

export const typoStyles = css<{
    name: TTypoName
    size: TTypoSize
}>`
    ${({ name, size }) => {
        switch (name) {
            case 'display':
                return () => {
                    switch (size) {
                        case 'large':
                            return display.large
                        case 'medium':
                            return display.medium
                        case 'small':
                            return display.small
                        default:
                            break
                    }
                }
            case 'headline':
                return () => {
                    switch (size) {
                        case 'large':
                            return headline.large
                        case 'medium':
                            return headline.medium
                        case 'small':
                            return headline.small
                        default:
                            break
                    }
                }
            case 'title':
                return () => {
                    switch (size) {
                        case 'extraLarge':
                            return title.extraLarge
                        case 'large':
                            return title.large
                        case 'medium':
                            return title.medium
                        case 'small':
                            return title.small
                        default:
                            break
                    }
                }
            case 'label':
                return () => {
                    switch (size) {
                        case 'large':
                            return label.large
                        case 'medium':
                            return label.medium
                        case 'small':
                            return label.small
                        default:
                            break
                    }
                }
            case 'body':
                return () => {
                    switch (size) {
                        case 'large':
                            return body.large
                        case 'medium':
                            return body.medium
                        case 'small':
                            return body.small
                        default:
                            break
                    }
                }
            case 'paragraph':
                return () => {
                    switch (size) {
                        case 'large':
                            return paragraph.large
                        case 'medium':
                            return paragraph.medium
                        case 'small':
                            return paragraph.small
                        default:
                            break
                    }
                }
            default:
                break
        }
    }}
`

export const Typo = styled.div<{
    name: TTypoName
    size: TTypoSize
    color: string
    fontFamily: string
}>`
    color: ${({ color }) => color};
    font-family: ${({ fontFamily }) => fontFamily}, Arial, sans-serif;
    font-style: normal;
    margin: 0;
    padding: 0;
    ${typoStyles}
`
